import { useState, useEffect } from "react";
import { makeStyles, Typography, Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { NoDataCard } from "../../../../../components/parts";
import { CustomPieChart } from "../../../../../components/charts";
import { getData } from "../../../../../services";

const useStyles = makeStyles(() => ({
  box: {
    marginTop: 15,
    height: 400,
  },
}));

export const SupplyRevenuesTotal = ({ buildingId, complexId, title }) => {
  const classes = useStyles();
  const [chartData, setChartData] = useState([]);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  let url = `/praas/v1/buildings/supply-revenues-total/`;
  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/supply-revenues-total/`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/supply-revenues-total/`;
  }

  useEffect(() => {
    getData(url, (data) => {
      setChartData([
        {
          name: "Rental revenues",
          value: Math.round(data.rental_revenue) ? data.rental_revenue : 0,
          color: COLORS.cian,
          unit: currencySymbol,
          key: "rental_revenue",
        },
        {
          name: "Power revenues",
          value: Math.round(data.power_revenue),
          color: COLORS.purple,
          unit: currencySymbol,
          key: "power_revenue",
        },
        {
          name: "Tenants rebate",
          value: Math.round(data.tenants_rebate) ? data.tenants_rebate : 0,
          color: COLORS.grey,
          strokeColor: COLORS.purple,
          strokeWidth: 1.5,
          unit: currencySymbol,
          key: "tenants_rebate",
        },
      ]);
    });
    return () => setChartData([]);
  }, [complexId, buildingId]);

  if (!chartData.length) {
    return <NoDataCard title={title} type="pie" />;
  }

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">{title}</Typography>
        <Box className={classes.box}>
          <CustomPieChart name="SupplyRevenuesTotal" data={chartData} />
        </Box>
      </Box>
    </ShaDowBox>
  );
};
